import api from '@/service';
import { nextTick, ref } from 'vue-demi';
import { session } from '@/utils/storage';
import { verificaPsw } from '@/useable/verification';
import { Message } from 'element-ui';
import config from '@/config';
import { removePending } from '@/useable/cancelRequest';
import router from '@/router';
import { computed } from '@vue/composition-api';
import md5 from 'js-md5';
import { encrypt } from '@/utils/aes';

const userInfor = ref(JSON.parse(session.get('user-infor') || '{}'));
let expires = session.get('user-infor', true)?.expires;
let refreshing = false;
let message;

const loginState = computed(() => {
  return !!userInfor.value.token;
});
const isCore = computed(() => {
  return userInfor.value.isCore;
});

const logout = async (byHand=false): Promise<void> => {
  removePending(); // 取消多余请求
  session.remove('user-infor');
  userInfor.value = {};
  await router.push({ name: 'Login' });
  await nextTick();
  if (!byHand) {
    if (message) message.close();
    message = Message.error('登录状态已过期，请重新登录！');
  }
  location.reload();
  console.log('---- logout! ----');
};

const refreshToken = async (): Promise<void | boolean> => {
  if (refreshing) {
    return;
  }
  refreshing = true;
  const now = Date.now();

  const last = (expires - now) / (1000 * 60);

  if (expires && last > 0 && last < 1) {
    const res = await api.login.refreshToken();

    if (res.code === 2000) {
      const oldUserInfo = JSON.parse(session.get('user-infor') || '{}');
      userInfor.value = Object.assign(oldUserInfo, { token: res.data });
      session.set('user-infor', JSON.stringify(oldUserInfo), config.session_maxAge);
      expires = Date.now() + config.session_maxAge;

      console.log('---- refresh token success! ----');
    }
  } else if (expires && last > 1){
    console.log('---- token still has effect! ----');
  } else {
    await logout();
    console.log('---- token expired! ----');
  }
  refreshing = false;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useLogin = async (params: any) => {
  if (!loginState.value) {
    if (!verificaPsw(params.password)) {
      Message.error('密码应该为大小写字母、数字组合或特殊字符任意三种，8至位15位！');
      return;
    }

    const res = await api.login.login({
      workEmail: encrypt(params.workEmail),
      password: md5(params.password),
      supplierId: encrypt(params.supplierId),
      checkCode: encrypt(params.checkCode)
    });

    if (res.code === 2000) {
      const oldUserInfo = JSON.parse(session.get('user-infor') || '{}');
      userInfor.value = Object.assign(oldUserInfo, {
        token: res.data.token,
        isCore: res.data.isCore,
        supplierCertId: params.supplierCertId,
        supplierId: params.supplierId,
        supplierName: params.supplierName,
        name: res.data.name,
      });
      session.set('user-infor', JSON.stringify(oldUserInfo), config.session_maxAge);
      expires = Date.now() + config.session_maxAge;
      console.log('---- login success! ----');
      await nextTick();
    }
  }
};

export {
  userInfor,
  logout,
  useLogin,
  refreshToken,
  loginState,
  isCore
};
